export class LayoutEventKeys {
    static readonly BlockMenuEventName = "BlockMenuEvent";
}